import { CommonModule, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { NgxCurrencyDirective } from 'ngx-currency';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { RecaptchaModule, RecaptchaFormsModule, RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';
import * as ENV from '../../environments/environment';
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        TranslateModule.forChild(),
        MatBadgeModule,
        MatDialogModule,
        MatIconModule,
        MatSelectModule,
        MatInputModule,
        MatRadioModule,
        MatAutocompleteModule,
        MatExpansionModule,
        MatProgressBarModule,
        NgbModule,
        MatListModule,
        MatCheckboxModule,
        NgxCurrencyDirective,
        NgxMaskDirective,
        NgxMaskPipe,
        RecaptchaModule,
        RecaptchaFormsModule,
    ],
    declarations: [
    ],
    providers: [
        DecimalPipe,
        {
            provide: RECAPTCHA_SETTINGS,
            useValue: { siteKey: ENV.environment.recaptcha.siteKey } as RecaptchaSettings
        },
        provideNgxMask()
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        TranslateModule,
        MatBadgeModule,
        MatIconModule,
        MatDialogModule,
        MatSelectModule,
        MatInputModule,
        MatRadioModule,
        MatAutocompleteModule,
        MatExpansionModule,
        MatProgressBarModule,
        NgbModule,
        NgxCurrencyDirective,
        NgxMaskDirective,
        NgxMaskPipe,
        RecaptchaFormsModule,
        RecaptchaModule
    ]
})
export class SharedModule {}




